module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-04-a19fd41a96f3e2960d3f4920a0612e7b.svg";